import { connect } from 'react-redux'
import get from 'lodash/get';

import {
  getSavedReports as onGetSavedReports
} from './../../actions/savedReportsActions'

const mapStateToProps = (state) => ({
  savedReportsDataState: state.savedReports.dataState,
  savedReportsData: get(state, ['savedReports', 'list'], []),
  savedReportsTotal: get(state, ['savedReports', 'total'], 0)
})

const mapDispatchToProps = {
  onGetSavedReports
}

const withSavedReports = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withSavedReports }